import { PaneArea } from '../../../../types/shared'
import EllipseV1, { IEllipseAttrs } from '../../../canvas/ellipse/ellipse_v1'
import PaneModel from '../../../models/pane'

type Area = PaneArea
type Attrs = IEllipseAttrs
type PartialAttrs = Partial<Attrs>

class EllipseV1Creator extends EllipseV1<Attrs> {
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    const xAxisOffset = this.model.scale.x.width(30)
    const yAxisOffset = this.model.scale.y.height(30)
    this.attrs.x1 = startArea.x - xAxisOffset
    this.attrs.x2 = startArea.x + xAxisOffset
    this.attrs.y1 = startArea.y - yAxisOffset
    this.attrs.y2 = startArea.y + yAxisOffset
    this.attrs.cursorTargetX = startArea.x + xAxisOffset
    this.attrs.cursorTargetY = startArea.y

    setTimeout(() => {
      this.replaceMyself(EllipseV1.fromObject<EllipseV1>(this.attrs, this.model))
      toolsCallback()
    })

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }
}

export default EllipseV1Creator
